module.exports = __webpack_public_path__ + "img/no-bots-light.ac3aa309.svg";